import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';

import * as _ from 'underscore';

// Service
import { AccountListService } from '../../service/account-client-list/account-client-list.service';

@Component({
	selector: 'app-account-client-list',
	templateUrl: './account-client-list.component.html',
	providers: [
		AccountListService,
		HttpModule
	]
})

export class AccountClientListComponent implements OnInit {

	private token = 
	localStorage.getItem('yara.token');
	public accountClients: any[];
	public resultCount: number = 0;
	public orderby: string = "Nome";
	public sort: string = "asc";
	public permissoes: any[] = [];
	public pesquisado: Boolean = false;
	currentPage: number = 0;
	accountClient: FormGroup;
	fieldNumber: number = 0;
	public buscaOrdemVenda: Boolean = false;
	public numeroOrdemVenda: string = "";


	constructor(fb: FormBuilder, private AccountListService: AccountListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.accountClient = fb.group({
			'CodigoPrincipal': ['',Validators.maxLength(10)],
			'Nome': ['',Validators.maxLength(120)],
			'Documento': ['',Validators.maxLength(24)],
			'Apelido': ['',Validators.maxLength(120)],
			'GrupoEconomico': ['',Validators.maxLength(120)],
			'OrderNumber': ['',Validators.maxLength(10)]
		});
	}

	ngOnInit() {
		//this.searchAccountClient(this.accountClient.value, 0, false);
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchAccountClient(this.accountClient.value, this.currentPage, false);
	}

	searchAccountClient(value: any, page, isSearch) {
		this.pesquisado = true;
		if (isSearch) {
			this.orderby = "Nome";
			this.sort = "asc";
			this.currentPage = 0;
		}

		this.buscaOrdemVenda = value.OrderNumber != "" && value.OrderNumber != null && value.OrderNumber != 0;
		this.numeroOrdemVenda = value.OrderNumber;

		this.AccountListService.getAccountClient(
			this.token,
			value.CodigoPrincipal,
			value.Nome,
		    value.Documento.replace(/[^a-zA-Z0-9]+/g, ''),
			value.Apelido,
			value.GrupoEconomico,
			value.OrderNumber,
			this.orderby,
			this.sort,
			page).subscribe(result => {
				if (result.Success) {
					this.accountClients = result.Result;
					this.resultCount = result.Count;
					console.log("Contas",this.accountClients);
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);

			})
	}

	//Count the number of fields not empty
	fieldCounter(){
		this.fieldNumber = 0;
		if (this.accountClient.value.CodigoPrincipal != ""
				&& this.accountClient.value.CodigoPrincipal != null
				&& this.accountClient.value.CodigoPrincipal != 0) {
			this.fieldNumber = this.fieldNumber + 1;
		}
		if (this.accountClient.value.Nome != ""){
			this.fieldNumber = this.fieldNumber + 1;
		}
		if (this.accountClient.value.Apelido != ""){
			this.fieldNumber = this.fieldNumber + 1;
		}
		if (this.accountClient.value.Documento != ""){
			this.fieldNumber = this.fieldNumber + 1;
		}
		if (this.accountClient.value.GrupoEconomico != ""){
			this.fieldNumber = this.fieldNumber + 1;
		}
		if (this.accountClient.value.OrderNumber != ""
				&& this.accountClient.value.OrderNumber != null
				&& this.accountClient.value.OrderNumber != 0) {
			this.fieldNumber = this.fieldNumber + 1;
		}
	}

	clearFields(){
		this.accountClient.setValue({
			'CodigoPrincipal': '',
			'Nome': '',
			'Documento': '',
			'Apelido': '',
			'GrupoEconomico': '',
			'OrderNumber' : ''});
		this.fieldCounter();
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchAccountClient(this.accountClient.value, $event, false);
	}

}



// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-list/account-client-list.component.ts